import script from "./WelcomeModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./WelcomeModal.vue?vue&type=script&lang=ts&setup=true"

import "./WelcomeModal.vue?vue&type=style&index=0&id=1f668eb5&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f668eb5"]])

export default __exports__